import React, { useState,useEffect } from 'react'
import { Autocomplete, ThemeProvider,Notification,IconButton} from '@workboard/wobo-ui'
import AddIcon from '@material-ui/icons/AddCircleOutline';
import Clear from '@material-ui/icons/Clear';
import { useTranslation } from 'react-i18next';
import BrowseTagModel from '../modals/browseTag.modal'
import KrTagService from '../services/krTag.service'
import { uniqueArrayObject } from '../../utils/function';
import  '../../../src/components/okr/wizard/suggestedTags.scss';
import ImgIconComp from '../../../src/components/imgcomp';
import GoalServices from '../../services/goal.services';
import styled from 'styled-components';
import { Button } from '@workboard/wobo-ui';
import { useClosedKrLock } from '../../components/okr/wizard/closedKrLock.context';



const StyledIconButton = styled(IconButton)`
    width: 22px;
    height: 14px;
    svg {
      width: 18px;
      height: 18px;
    }
    color:#0072AB;
    margin-top:2px;
`;

const  Goalservices = new GoalServices()
const AddKrTag = (props:any) => {
  const { metric, goalId } = props;
  const tagServices = new KrTagService();
  const [tagList, setTagList] = useState([])
  const [currentTag, setCurrentTag] = useState(metric.krTags || [])
  const [showDsList, showDsvalue] = useState(true)
  const [showSearch, showSearchHandle] = useState(false)
  const [searchAddedTags, setSearchAddedTAgs] = useState([])
  const [newTagIds, setNewTagId] = useState([])
  const [activeTagsData,setactiveTagsData]=useState( props.selectednlplTags&&props.selectednlplTags.length>0?props.selectednlplTags:new Array(5).fill(null))
  const [rerender,setRerender] = useState(true)
  const [selectednlplTagsName,setSelectednlplTagsName]=useState(props.selectednlplTagsName?props.selectednlplTagsName:[])
  const [suggestedVisible,setSuggestedVisible] = useState(true)
  const [tagsList,setTagsList] = useState(props.tagsList?props.tagsList:[])
  const [notification,setNotification]=useState(false)
  const [severity,setSeverity] = useState('')
  const [addRemove,setAddRemove] = useState('')
  const [currentTagname,setCurrentTagName]=useState('')
  let nameArray =[]
  let propsArray = activeTagsData
  propsArray.map((item)=>{
      item && nameArray.push(item.id)
  })
  let tagsCount = selectednlplTagsName.length + newTagIds.length
  const tagsCountUpdateOnClick_x=()=>{
    const tagId = []
    setSuggestedVisible(false)
    props.updateTags([])
     setSelectednlplTagsName([])
     tagsList.map((item)=>{
      tagId.push(item.id)
     })
     krTagEvent(tagId, false , false)
  }
  const toggleClass = (index) => {
    if(JSON.stringify(tagsList[index])===JSON.stringify(activeTagsData[index])){
      nameArray=selectednlplTagsName
      propsArray.splice(index, 1, null) 
      setactiveTagsData(propsArray)
      nameArray =[]
      propsArray.map((item)=>(
        item && nameArray.push(item.id)
      ))
      setSelectednlplTagsName(nameArray)
      setRerender(!rerender)
      setCurrentTagName(tagsList[index].name)
      setNotification(true)
      setSeverity("success")
      setAddRemove("removed from")
    }else{
      setNotification(true)
      setSeverity("success")
      setAddRemove("applied to")
      setCurrentTagName(tagsList[index].name)
      propsArray.splice(index, 1,tagsList[index])
      setactiveTagsData(propsArray)
      nameArray =[]
      propsArray.map((item)=>(
        item && nameArray.push(item.id)
      ))
      setSelectednlplTagsName(nameArray)
      setRerender(!rerender)
    }
    props.updateTags(nameArray);
    krTagEvent([tagsList[index].id], true, true)
    krTagEvent([tagsList[index].id], true, false)
  }
  const toggleActiveIcon = (index) => {
    if (
      JSON.stringify(tagsList[index]) === JSON.stringify(activeTagsData[index])
    ) {
      return '✓'
    } else {
      return '+'
    }
  }
  const toggleActiveClass = (index) => {
    if (
      JSON.stringify(tagsList[index]) === JSON.stringify(activeTagsData[index])
    ) {
      return 'tages-temp clicked'
    } else {
      return 'tages-temp unclicked'
    }
  }  

  const toggleActiveare = (index) => {
    if (
      JSON.stringify(tagsList[index]) === JSON.stringify(activeTagsData[index])
    ) {
      return true
    } else {
      return false
    }
  }  
   
  const { t } = useTranslation();
  const isClosedKr = useClosedKrLock();
  useEffect( () => {
    let tempTagArray=[]
   if(currentTag.length>0){
    currentTag.map((item)=>{
      tempTagArray.push(item.id)
    })
   }
   { if(props.tagsList&&props.tagsList.length<1&&props.searchText) {Goalservices.getNlplTagsData({term:props.searchText}).then((result) => {
      let tagListdata=result.data.data
      tagListdata = tagListdata.filter(val => !tempTagArray.includes(val.id));
      setTagsList(tagListdata)
    })}}
    if((nameArray && nameArray.length>0)||(currentTag&&currentTag.length>0)){
      showDsvalue(false)
      showSearchHandle(true)
    
    }
    setCurrentTag(metric.krTags || [])
    initialIndex() 
    document.addEventListener('keydown', handleClick)
    return () => {
      document.removeEventListener('keydown', handleClick);
    }
 }, []);
 
  useEffect(() => {
    if (showSearch) {
      const focusEl: HTMLElement = document.querySelector<HTMLInputElement>('[data-testid="tag-search-box"] input') as HTMLElement;
      focusEl?.focus();
    }
  }, [showSearch]);

  const handleClick = (e) => {
    if(e.keyCode == 13 && e.target.tagName == 'INPUT') {
      e.preventDefault();
    }
  }
  const showHideDsList = (act:boolean) => {
    showDsvalue(!act)
  }

  const initialIndex = () => {
    const idarray = [...newTagIds]
    const current = [...currentTag]
    current.forEach((data) => {
      let a = data.id
      idarray.push(a)
    })
    setNewTagId(idarray)
    props.taghandler(idarray);
  }

  const removeTag = (id:any, type:number) => {
    if (type == 1) {
      const tempTags = [...currentTag]
      const tagindex = tempTags.findIndex((x) => x.id === id)
      tempTags.splice(tagindex, 1)
      setCurrentTag(tempTags)
      const idarray = [...newTagIds]
      const filteredAry = idarray.filter(e => e !== id)
      setNewTagId(filteredAry)
      props.taghandler(filteredAry);
      if(tempTags.length === 0) {
				document.getElementById("kr-tag-search")?.focus()
			} else {
        	focusOnNextTag('.selected-tag');
      }
    } else {
      const tempTags = [...searchAddedTags]
      const tagindex = tempTags.findIndex((x) => x.id === id)
      tempTags.splice(tagindex, 1)
      setSearchAddedTAgs(tempTags)
      const idarray = [...newTagIds]
      const filteredAry = idarray.filter(e => e !== id)
      setNewTagId(filteredAry)
      props.taghandler(filteredAry);
      if(tempTags.length === 0) {
				document.getElementById("kr-tag-search")?.focus()
			} else {
        	focusOnNextTag('.searched-tag');
      }
    }
  }

  const focusOnNextTag = (classNameToBeFocused) => {
      const focusableRemoveElements = document.querySelectorAll(classNameToBeFocused);
		  const focusableRemoveArr = Array.prototype.slice.call(focusableRemoveElements);
		  const firstRemoveBtn = focusableRemoveArr[0];
			if (firstRemoveBtn) {
        		firstRemoveBtn?.focus();
      	}
  }

  const showHideSearch = () => {
    showSearchHandle(!showSearch)
    showHideDsList(showDsList)
  }

  const handlesearchadd = (key) => {
    const initialSearchArray = [...searchAddedTags]
    const idarray = [...newTagIds]
    const findTag = currentTag.find((t) => t.id == key.id);
    if (!findTag) {
      initialSearchArray.push(key)
      idarray.push(key.id)
    }
    setSearchAddedTAgs(uniqueArrayObject(initialSearchArray, 'id'))
    setNewTagId(idarray)
    props.taghandler([...new Set([...idarray])]);
  }

  const getData = async(term) => tagServices.searchKrTags(term)

  const tagSearch = async (term) => {
    if (term.length >= 1) {
      const response = await getData({
        term,'goalId': goalId
      })
      const searchresults = response.data.data.tags
      setTagList(searchresults);
    }
  } 

const getBrowseTag = (tags) => {
let tagList1 = currentTag.map((x)=>{return x.id})
let tagList2 = tags.map((x)=>{return x.id})
props.taghandler(tagList2);
let ctag = tagList2.filter(val => tagList1.includes(val));
let ctags = tags.filter(val => ctag.includes(val.id));
tags = tags.filter(val => !tagList1.includes(val.id));
let temp = [...newTagIds]
    tags.forEach((data) => {
      let a = data.id
      temp.push(a)
    })
temp = [...new Set(temp)]
setNewTagId(temp)
setSearchAddedTAgs(tags)
setCurrentTag(ctags)
}
const handleUserKeyPress = (e) => {
  if (e.keyCode === 13 || e.keyCode === 32) {
    showHideDsList(showDsList)
  }
};
const handleUserKeyPressDelete = (e,id,type) => {
  if (e.keyCode === 13 || e.keyCode === 32) {
    removeTag(id,type)
  }
  
};

const krTagEvent = (tagId, tagSelection, first) =>{
  // first is true if api is called first time
  let ref = ''
  if(tagSelection && first){
    ref = 'KR_TAG_SUGGESTION_ACCEPTED'
  }
  if(tagSelection && !first){
    ref = 'KR_TAG_ADDED'
  }
  if(!tagSelection){
    ref = 'KR_TAG_SUGGESTION_DECLINED'
  }
  const source = props.metric.id?'kr_edit':'kr_create'
  let params : any = {}
  params.tagId=tagId
  params.ref = ref
  params.source = source
   Goalservices.krTagEvents(params)
}

  if (isClosedKr) {
    return (
      <ThemeProvider>
        <div className="krtag-block" data-testid="krtag-block">
          {currentTag.length > 0 ? (
            <div className="current-tag-container" data-testid="closed-kr-tags">
              <div style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '8px' }}>
                {t('Key Result Tags ') + `(${currentTag.length})`}
              </div>
              {currentTag.map((item) => (
                <div
                  key={item.id}
                  className="chip selected-tag"
                  style={{ borderRadius: '20px' }}
                  title={item.name}
                  data-testid={`closed-kr-tag-${item.id}`}
                >
                  <div className="chip-content">{item.name}</div>
                </div>
              ))}
            </div>
          ) : (
            <Button
              data-testid="closed-kr-tags-button"
              style={{ padding: '4px 4px 4px 0px', fontSize: '14px', fontWeight: 700, minWidth: 0, justifyContent: 'flex-start'}}
              kind="normal"
              variant="ghost"
              className="krAlign-label"
              isDisabled
              startIcon={<AddIcon style={{ width: '18px', margin: '0px 0px 0px 4px' }} />}
            >
              {t('Tags')}
            </Button>
          )}
        </div>
      </ThemeProvider>
    )
  }

  return (
    <ThemeProvider>
      <div className="krtag-block" data-testid="krtag-block" style={{display:showDsList && suggestedVisible?'flex':''}}>
        <div
          role="button"
          className="dsTextLabel addtagHeading"
          style={{ display: 'flex' }}
          onClick={() => showHideDsList(showDsList)}
          onKeyUp={handleUserKeyPress}
          aria-expanded={!showDsList}
          data-testid="add-tag"
        >
          <div tabIndex={0}>
            { showDsList &&
              <div style={{display: 'flex', flexDirection: 'row'}}>
                <Button
                  style={{ padding: '4px 4px 4px 0px', fontSize: '14px', fontWeight: 700, minWidth: 0, justifyContent: 'flex-start'}}
                  kind="normal"
                  onClick={() => showHideSearch()}
                  variant="ghost"
                  className="krAlign-label"
                  startIcon={<AddIcon
                    style={{
                      cursor: 'pointer',
                      width: '18px',
                      color: '#596373',
                      fontWeight: 700,
                      margin: '0px 0px 0px 4px',
                    }}
                    />
                  }
                >
                  {t('Tags')}
                </Button>
              </div>
            }
            { !showDsList && <div style={{display: 'flex', flexDirection: 'row'}}>
              <div
                className={'show-CatUp icon icon-dropdown-14px'}
                data-testid="add-tag-arrow"
                style={{ marginTop: '4px' }}
              ></div>
              <div
                style={{ color: '#596373', fontWeight: 700, fontSize: '14px' }}
                onClick={() => showHideSearch()}
              >
                {t('Key Result Tags ') + `(${tagsCount})`}
              </div>
            </div>}
          </div>
        </div>
        {showDsList && suggestedVisible && tagsList.length > 0 ? (
          <>
            <div
              tabIndex={0}
              className="suggestion"
              style={{
                width: '220px',
                marginLeft: '14px',
                marginTop: '6px',
                paddingTop: '2px',
                cursor: 'pointer',
                height:'fit-content'
              }}
              onClick={() => showHideSearch()}
            >
              {
                <ImgIconComp
                  id="kr_cluster_1x"
                  width="20px"
                  marginRight="0px"
                  height="20px"
                  class="lightBlub"
                />
              }
              {/* <span   tabIndex={0} 
                role='option'
                  style={{cursor:'pointer',marginLeft:'-8px', marginRight:'5px',fontWeight:'bold'}}
                  onClick={(e)=>setSuggestedVisible(false)}
                  aria-selected={!suggestedVisible}
                  onKeyPress={(e)=>setSuggestedVisible(false)}
                >
                  X
                </span> */}              
              <div style={{marginTop:'2px', width: "140px"}}> { tagsList && tagsList.length > 0 ? tagsList.length : ''} &nbsp; {t('Suggested Tags')}</div>
              <StyledIconButton
                role="option"
                aria-label={t("Remove Suggested Tags")}
                style={{paddingTop:'10px'}}
                aria-selected={suggestedVisible}
                onClick={() => {
                  tagsCountUpdateOnClick_x()
                }}
                onKeyPress={() => {
                  tagsCountUpdateOnClick_x()
                }}
              >
                <Clear />
              </StyledIconButton>
            </div>
          </>
        ) : null}
        {!showDsList && (
          <div className="add-tag-button">
            <br />
            <div className="krBreak" aria-hidden="true" />
            {!showDsList && (
              <div className="search-area"
              data-testid="add-tag-search">
                <div style={{ marginTop: '10px' }} id="autocomplete-area">
                  <Autocomplete
                    id="kr-tag-search"
                    autoHighlight={false}
                    autoSelect={false}
                    label={`${t('Add key result tags')}`}
                    icon={false}
                    placeholder={t("Search and add tags by groups or name")}
                    style={{ width: 368 }}
                    options={tagList}
                    getOptionLabel={(option) => option.name}
                    startMatch={false}
                    onChange={(e, v) => handlesearchadd(v)}
                    template={SearchList}
                    filterOptions={(x) => x}
                    value={''}
                    query={async (term) => {
                      if (term) {
                        return tagSearch(term)
                      }
                      return []
                    }}
                    rootProps={{
                      'aria-labelledby': 'tag_group_dropdown', // ARIA attribute example.
                      'data-testid': 'tag-search-box', // Automation id example.
                    }}
                    panelProps={{ className: 'autocomplete-list' }}
                    className="okrAddtagsInput"
                  />
                </div>
                <br />

                {searchAddedTags && searchAddedTags.length > 0 && (
                  <div
                    className="search-added-labels"
                    data-testid="search-added-labels"
                  >
                    {searchAddedTags.map((item, index) => (
                      <TagLabel
                        governance="governance"
                        name={item.name}
                        id={index}
                        deleteFunction={() => removeTag(item.id, 2)}
                        handlekey={(e) =>
                          handleUserKeyPressDelete(e, item.id, 2)
                        }
                        class="searched-tag"
                      />
                    ))}
                  </div>
                )}

                <BrowseTagModel
                  closeToastMessage={false}
                  currentTags={[...currentTag, ...searchAddedTags]}
                  getTags={getBrowseTag}
                  metric={metric}
                  goalId={goalId}
                />
                {currentTag.length > 0 ? (
                  <div className="current-tag-container">
                    <div
                      style={{
                        height: '20px',
                        fontWeight: 'bold',
                        fontSize: '14px',
                        marginBottom: '8px',
                        marginLeft: '14px',
                      }}
                    >
                      {t('Selected KR tags')}:
                    </div>
                    {currentTag.map((item, index) => (
                      <TagLabel
                        governance="governance"
                        name={item.name}
                        id={index}
                        deleteFunction={() => removeTag(item.id, 1)}
                        handlekey={(e) =>
                          handleUserKeyPressDelete(e, item.id, 1)
                        }
                        class="selected-tag"
                      />
                    ))}
                  </div>
                ) : null}
                {tagsList && tagsList.length > 0 && suggestedVisible ? (
                  <>
                    <div className="parent-temp">
                      <div className="container-temp">
                        <div
                          className="suggestion-temp"
                          tabIndex={0}
                          style={{ width: '190px',height:'fit-content' }}
                          aria-label={t("Remove Suggested Tags")}
                          data-testid="suggestion-tag-text"
                        >
                          {
                            <ImgIconComp
                              id="kr_cluster_1x"
                              width="20px"
                              height="20px"
                              class="lightBlub"
                            />
                          }
                          {/* <span tabIndex={0}  onKeyPress={()=>setSuggestedVisible(false)}  onClick={()=>setSuggestedVisible(false)}>X</span> */}
                          <div  style={{ width: '120px',marginTop:'2px'}}> { tagsList && tagsList.length > 0 && tagsList.length } &nbsp; {t('Suggested Tags')}</div>
                          <StyledIconButton
                            role="option"
                            className=""
                            onClick={() => {
                              tagsCountUpdateOnClick_x()
                            }}
                            aria-selected={suggestedVisible}
                            onKeyPress={() => {
                              tagsCountUpdateOnClick_x()
                            }}
                            aria-label={t("Remove Suggested Tags")}
                          >
                            <Clear />
                          </StyledIconButton>
                        </div>
                        <div className='right-temp' style={{ width: '90%' }}>
                          {tagsList &&
                            tagsList.length > 0 &&
                            tagsList.slice(0, 5).map((item, i) => (
                              <div
                                data-testid="nlp-tags"
                                role="option"
                                className={toggleActiveClass(i)}
                                aria-selected={toggleActiveare(i)}
                                // aria-checked={toggleActiveare(i)}
                                onClick={() => {
                                  toggleClass(i)
                                }}
                                tabIndex={0}
                                onKeyPress={() => {
                                  toggleClass(i)
                                }}
                              >
                                <span>{toggleActiveIcon(i)}</span>
                                <div>{' ' + item.name}</div>
                                {item.name.length > 20 && (
                                  <div title={item.name}>...</div>
                                )}
                              </div>
                            ))}
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ''
                )}
              </div>
            )}
          </div>
        )}
      </div>
      <Notification
        open={notification}
        message={`${currentTagname} have been ${addRemove} key result.`}
        severity={severity}
        anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
        onClose={() => {
          setNotification(false)
          setSeverity('')
        }}
      />
    </ThemeProvider>
  )
}

export function TagLabel(props) {
  const { showCloseButton = true, handleClick } = props;
  return (
    <div className={props.noBorder ? `chip noBorder + ${props.class}` : `chip + ${props.class}`}  
      tabIndex={0} 
      style={props.governance&& {borderRadius:'20px'} }
      onKeyUp={props.handlekey} 
      aria-label={`Delete ${props.name} on space or enter`}
      role="button"
      data-testid="tag-chip" id={props.id}
      {...(props.handleClick) && {onClick: (e) => handleClick(e, props)}}
    >
      
      <div className="chip-content">{props.name}</div>
      {props.name.length>20 &&
       <div title={props.name}>{'  '}...{'  '}</div>
      }
      {
        showCloseButton 
        && <img
        data-testid='tag-close'
        className="tag-close"
        onClick={props.deleteFunction}
        src={wbConfig.baseUrl + '/images/okr/close-vector.png'}
        alt=""
        aria-hidden="true"
      />
      }
    </div>
  )
}
const SearchList = ({ ...props }) => {
  return (
    <div className="searchlistspan" data-testid="tag-search-item">
      <div className="tag-name-heading truncate">{props.name}</div>
      <div className="tag-group-heading truncate">{props.tagGroupName}</div>
    </div>
  )
}

export default AddKrTag
